import React, { useEffect, useRef } from "react";
import { useApolloClient, useQuery } from "react-apollo";
import { useSelector } from "react-redux";
import { IState } from "../../redux/reducers";
import { ATUALIZACAO_CADASTRAL_PENDENTE, AtualizacaoCadastralPendenteQuery } from "./atualizacaoCadastralGql";
import AtualizacaoCadastralDialog from "./AtualizacaoCadastralDialog";
import { ouvirBloqueioAtualizacaoCadastral } from "./avisoBloqueio";

/**
 * Exibe o modal de atualizacao cadastral quando o usuario tem atualizacao cadastral pendente.
 *
 * So consulta depois que o usuario foi liberado no sistema (apos o Painel de Cadastro).
 * Enquanto houver pendencia o servidor recusa as demais operacoes; ao salvar, as queries
 * da tela sao refeitas — inclusive esta, que entao volta sem pendencia e fecha o modal.
 *
 * Se esta consulta falhar, o servidor deixa de bloquear o usuario. Se ainda assim alguma operacao
 * for recusada por pendencia, a consulta e refeita para abrir o modal.
 */
const AtualizacaoCadastral = () => {
  const client = useApolloClient();
  const isAllowed = useSelector((state: IState) => state.allowReducer.isAllowed);
  const { data, refetch } = useQuery<AtualizacaoCadastralPendenteQuery>(ATUALIZACAO_CADASTRAL_PENDENTE, {
    skip: !isAllowed,
    fetchPolicy: "network-only",
  });

  // Varias queries da tela sao recusadas juntas: uma unica consulta de pendencia por vez basta.
  const consultando = useRef(false);
  useEffect(() => {
    if (!isAllowed) {
      return undefined;
    }
    return ouvirBloqueioAtualizacaoCadastral(() => {
      if (consultando.current) {
        return;
      }
      consultando.current = true;
      refetch()
        .catch(() => undefined)
        .then(() => {
          consultando.current = false;
        });
    });
  }, [isAllowed, refetch]);

  const pendencia = data ? data.atualizacaoCadastralPendente : null;
  if (!isAllowed || !pendencia || !pendencia.pendente || !pendencia.campos || pendencia.campos.length === 0) {
    return null;
  }

  return (
    <AtualizacaoCadastralDialog
      key={(pendencia.atualizacoes || []).join(",")}
      titulo={pendencia.titulo || "Atualização cadastral"}
      mensagem={pendencia.mensagem || ""}
      campos={pendencia.campos}
      onSalvo={() => client.reFetchObservableQueries()}
    />
  );
};

export default AtualizacaoCadastral;
